import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { SubMenu } from 'react-pro-sidebar';
import { verify_path } from '../utils/getPermissions';

interface Props {
  children: JSX.Element[] | JSX.Element;
  pathList: string[];
  pathName: string;
  label: string;
  collapsed: boolean;
  icon?: ReactElement | null;
  showingMainMenu?: boolean;
  itemId?: number;
  onToggle?: (itemId: number) => void;
}

const SubMenuComponent = ({
  children,
  pathList,
  pathName,
  label,
  collapsed,
  showingMainMenu,
  icon = null,
  itemId,
  onToggle,
}: Props) => {
  const [selectedMenu, setSelectedMenu] = useState<boolean>(!collapsed);

  const submenuRef = useRef<any>();

  /**
   * Helper function to recursively calculate all paths
   * for the current menu and its children
   */
  const getAllPaths = (children: JSX.Element[] | JSX.Element): string[] => {
    let paths: string[] = [...pathList]; // Include current pathList
    React.Children.forEach(children, (child: any) => {
      if (child?.props?.pathList) {
        paths = paths.concat(child.props.pathList); // Add paths from children
      }
    });
    return paths;
  };

  useEffect(() => {
    // Sincronizar selectedMenu con collapsed prop
    setSelectedMenu(!collapsed);
  }, [collapsed]);

  useEffect(() => {
    const submenuNode = submenuRef.current;
    if (!submenuNode) return;
    const submenuContent = submenuNode.querySelector('.ps-submenu-content');
    if (!submenuContent) return;

    // Si pathName cambió y está en nuestras rutas, abre
    const allPaths = getAllPaths(children);
    if (verify_path(allPaths, pathName)) {
      setSelectedMenu(true);
    }
  }, [pathName, children]);

  useEffect(() => {
    const submenuNode = submenuRef.current;
    if (!submenuNode) return;
    const submenuContent = submenuNode.querySelector('.ps-submenu-content');
    if (!submenuContent) return;

    if (showingMainMenu && verify_path(pathList, pathName)) {
      setSelectedMenu(true);
    }
  }, [showingMainMenu, pathName, pathList]);

  const handleSubMenuToggle = () => {
    setSelectedMenu(!selectedMenu);
    if (itemId !== undefined && onToggle) {
      onToggle(itemId);
    }
  };

  return (
    <SubMenu
      ref={submenuRef}
      defaultOpen={selectedMenu}
      open={selectedMenu}
      onClick={handleSubMenuToggle}
      label={label}
      icon={icon}
    >
      {children}
    </SubMenu>
  );
};

export default SubMenuComponent;
